import React from 'react'

const MagazineIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      {/* Left Page Frame */}
      <path d="M5.92,13.12,28,15.93V43.71L5.92,39.55V13.12m-4-4.54V42.87L32,48.54V12.41L1.92,8.58Z" />

      {/* Left Page Lines */}
      <rect
        x="14.77"
        y="11.74"
        width="4"
        height="16.5"
        transform="translate(-5.31 33.89) rotate(-82.19)"
      />
      <rect
        x="14.77"
        y="18.61"
        width="4"
        height="16.5"
        transform="translate(-12.12 39.83) rotate(-82.19)"
      />
      <rect
        x="14.77"
        y="25.48"
        width="4"
        height="16.5"
        transform="translate(-18.93 45.77) rotate(-82.2)"
      />

      {/* Right Page Frame */}
      <path d="M58.08,13.12V39.55L36,43.71V15.93l22.08-2.81m4-4.54L32,12.41V48.54l30.08-5.67V8.58Z" />

      {/* Right Page Lines */}
      <rect
        x="38.98"
        y="17.99"
        width="16.5"
        height="4"
        transform="translate(-2.28 6.6) rotate(-7.8)"
      />
      <rect
        x="38.98"
        y="24.86"
        width="16.5"
        height="4"
        transform="translate(-3.21 6.66) rotate(-7.8)"
      />
      <rect
        x="38.98"
        y="31.74"
        width="16.5"
        height="4"
        transform="translate(-4.14 6.72) rotate(-7.8)"
      />

      {/* Bottom Page Detail / Shadow */}
      <path d="M16.65,52.36H16L3.7,51.74l.19-4,12.28.61a9.83,9.83,0,0,0,4.32-.76l.17-.07,10.73-3.44,1.22,3.81L22,51.31A14.05,14.05,0,0,1,16.65,52.36Z" />
      <path d="M45.29,52.36a13.89,13.89,0,0,1-5.4-1.09l-8.63-3.43,1.48-3.72,8.67,3.45a9.83,9.83,0,0,0,4.36.78l12.28-.61.2,4L46,52.35Z" />
    </svg>
  )
}

export default MagazineIcon
